import { render } from "./PosterItem.vue?vue&type=template&id=0c3131a8&scoped=true"
import script from "./PosterItem.vue?vue&type=script&lang=js"
export * from "./PosterItem.vue?vue&type=script&lang=js"

import "./PosterItem.vue?vue&type=style&index=0&id=0c3131a8&lang=scss&scoped=true"

import exportComponent from "/Users/rhizomedesign/Dropbox/2021/09-Dear Climate Site/Dear Climate Web/dear-climate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3131a8"]])

export default __exports__